import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UserOverviewType } from 'src/app/enum/user-overview-type.enum';
import { IEmployee } from 'src/app/models/employee.model';
import { ILeave } from 'src/app/models/leave.model';
import { AuthService } from 'src/app/services/auth.service';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-user-overview-box',
  templateUrl: './user-overview-box.component.html',
  styleUrl: './user-overview-box.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserOverviewBoxComponent {
  @Input() public firstText = '';
  @Input() public secondText = '';

  @Input() public type: UserOverviewType;

  @Input() public nextBirthdayData? = {} as IEmployee;
  @Input() public leavesOfToday?: ILeave[] = [];

  public currentEmployee = {} as IEmployee;

  public UserOverviewType = UserOverviewType;
  constructor(
    private authService: AuthService,
    public helperService: HelperService,
  ) {
    this.currentEmployee = this.authService.getCurrentEmployee();
  }

  public getShortEmployeeName(employeeName: string): string {
    const [firstName, lastName] = employeeName.split(' ');
    return `${firstName} ${lastName?.charAt(0)}.`;
  }

  public get leavesOfTodayTitle(): string {
    if (!this.leavesOfToday?.length) {
      return 'No leave';
    }
    return this.leavesOfToday.map((leave) => leave.employeeName).join('\n');
  }
}
